import { Actions } from 'vuex-smart-module';
import { ReserveVehicleState } from '@/store/reserve-vehicle/state';
import { ReserveVehicleGetters } from '@/store/reserve-vehicle/getters';
import { ReserveVehicleMutations } from '@/store/reserve-vehicle/mutations';
import Axios, { AxiosError } from 'axios';
import { ServiceContainer, ReserveVehicleService } from '@/services';
import { ReservedVehicleResponse } from '@/types/reserve-vehicle';

interface ReserveVehicleActionsDependencies {
	services: ServiceContainer;
}

export class ReserveVehicleActions extends Actions<
	ReserveVehicleState,
	ReserveVehicleGetters,
	ReserveVehicleMutations,
	ReserveVehicleActions
	> {
	self = this;

	reserveVehicleService!: ReserveVehicleService;

	$setDependencies(dependencies: ReserveVehicleActionsDependencies): void {
		this.self.reserveVehicleService = dependencies.services.reserveVehicle;
	}

	processError(payload?: AxiosError): Promise<void> {
		if (Axios.isCancel(payload)) {
			return Promise.resolve();
		}

		this.mutations.unsetLoading();

		return Promise.resolve();
	}

	async checkReservedVehicle(data: string): Promise<void> {
		this.mutations.setLoading();
		/*
		This code block is to remain commented out till we integrate a Payment Gateway System.
		 */
		// const response = await this.reserveVehicleService.checkReservedVehicle(data)
		// 	.catch(error => {
		// 		this.actions.processError(error);
		// 		this.mutations.unsetLoading();
		// 		this.mutations.unsetIsReservedVehicle();
		// 	});
		const response = {
			enabled: false,
			reserved: false,
			timeLimit: 0,
			depositAmount: 0,
		};

		if (response) {
			this.mutations.setReservedVehicleResponse(response);
			if (response.enabled) {
				if (response.reserved) {
					this.mutations.setIsReservedVehicle();
				} else {
					this.mutations.unsetIsReservedVehicle();
				}
				this.mutations.setReserveTimeLimit(response.timeLimit);
				this.mutations.setReserveDepositAmount(response.depositAmount);
				this.mutations.unsetLoading();
				this.mutations.setDisplayWidget();
			} else {
				this.mutations.unsetIsReservedVehicle();
				this.mutations.unsetReserveTimeLimit();
			}
		}

		return Promise.resolve();
	}
}
